module.exports = {"532927101":"南诏镇","532927102":"庙街镇","532927103":"大仓镇","532927104":"永建镇","532927201":"巍宝山乡","532927202":"马鞍山乡","532927203":"紫金乡","532927204":"五印乡","532927205":"牛街乡","532927206":"青华乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532927.json
// module id = 2654
// module chunks = 0